export const studio = {
  title: "AI Studio",
  description: "Captions in your brand voice, images for your feed, and a score for every post before it goes out.",
  tabs: { captions: "Captions", images: "Images", scorer: "Post scorer", history: "History" },
  captions: {
    title: "Caption generator",
    hint: "Describe the post; get three options in your tone and language.",
    empty: "Your captions will appear here",
    emptyHint: "Write a short brief and pick a tone.",
    copy: "Copy",
    copied: "Caption copied",
    usePost: "Use in a post",
    option: "Option {{n}}",
  },
  images: {
    title: "Image generation",
    prompt: "Describe the image",
    promptPlaceholder: "Abstract painting in azure and cyan, soft light, textured canvas, gallery wall",
    size: "Size",
    sizes: { square: "Square", portrait: "Portrait", landscape: "Landscape" },
    generate: "Generate image",
    generating: "Painting…",
    gallery: "Media library",
    galleryHint: "Generated images are saved to your media library.",
    empty: "No images yet",
    emptyHint: "Generate your first image: it will be saved here.",
    usePost: "Use in a post",
    open: "Open image",
    saved: "Saved to your media library",
    failed: "Couldn't generate the image",
    ideas: "Try",
    idea1: "Minimal gallery wall with three framed abstract prints",
    idea2: "Close-up of brush strokes in azure acrylic",
    idea3: "Cozy living room with a large blue painting above the sofa",
    running: "Generating in the background: you can leave this page, we'll tell you when it's ready.",
    failedTitle: "The image wasn't generated",
    retry: "Retry",
    result: "Generated image",
  },
  job: {
    running: "Working on it in the background…",
    failed: "It didn't work",
    retry: "Retry",
  },
  history: {
    title: "Your generations",
    hint: "Every AI generation runs as a job: retry the failed ones, reuse the results.",
    empty: "No generations yet",
    emptyHint: "Images, captions and scores you generate show up here.",
    all: "All",
    kinds: { ai_image: "Images", ai_image_edit: "Edits", ai_caption: "Captions", ai_occasion: "Calendar drafts", ai_score: "Scores", ai_rule: "Rules", ai_tts: "Voice", ai_stt: "Transcripts" },
    retry: "Retry",
    use: "Use",
    view: "View",
    delete: "Delete",
    deleted: "Removed from your history",
    deleteConfirm: "Remove this generation from your history? Its images stay in the media library.",
    size: "Size {{size}}",
    noPrompt: "No prompt",
    filter: "Filter by type",
  },
  scorer: {
    title: "Post scorer",
    hint: "Paste a caption to see what works and what to fix before you publish.",
    type: "Post type",
    placeholder: "Paste or write a caption…",
    usePost: "Open in composer",
  },
};
